export default "__VITE_ASSET__BHopy2ZT__"